<template>
    <div class="row">
        <div class="col-12 col-md-4">
            <div class="btn-group mt-3 d-md-none">
                <button class="btn btn-primary" type="button" data-toggle="collapse" data-target="#filters">
                    Filters<i class="las la-filter pl-1"></i>
                </button>
            </div>
            <div id="filters" class="collapse mt-3 stick">
                <button @click="resetFilters" id="resetFilter" class="btn btn-link text-success" type="button">
                    Reset
                </button>
                <button v-if="filters.search" @click="getProducts" id="applyFilter" class="btn btn-outline-primary"
                        type="button">
                    Apply
                </button>
                <div class="list-group mt-3 w-100">
                    <input @keyup.enter="getProducts" v-model="filters.search" class="form-control"
                           type="text" placeholder="Search">
                </div>
                <!-- Product Filters -->
                <div v-for="filterType in ['Categories', 'Genetics']" class="list-group mt-3 w-100">
                    <div v-if="productFilters[filterType.toLowerCase()].length  > 0" class="list-group h5 font-weight-bold mb-4">{{ filterType }}</div>
                    <div v-for="item in productFilters[filterType.toLowerCase()]" :key="item" class="list-group">
                        <label class="list-group-item-action">
                            <input @change="getProducts" v-model="filters[filterType.toLowerCase()]" :value="item"
                                   type="checkbox" :disabled="item.length>0?false:true" >
                            <span class="font-weight-bold">{{ item.length>0?item:"All" }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div ref="productTop" class="col-12 col-md-8 mt-3">
            <div class="list-group mt-3 w-100">
                <pagination :pagination="pagination" @fetch-results="getProducts"/>
            </div>

            <table class="table">
                <thead></thead>
                <tbody id="productTable">
                <template v-if="dataProducts.length > 0">
                    <tr v-for="product in dataProducts">
                        <td class="px-0">
                            <div class="position-relative">
                                <a :href="getProductURL(product.prdSlug)" class="stretched-link"></a>

                                <div class="row">
                                    <div class="col-sm-3 col-6 mt-3">
                                        <img v-if="!product.prdInStock"
                                             class="img-fluid stock-ribbon" alt="Product Out of Stock"
                                             src="https://dz8osaahf9pd7.cloudfront.net/images/assets/OutOfStockRibbon.png">
                                        <img class="img-fluid mx-auto" :src="product.prdImage" alt="product-image">
                                    </div>
                                    <div class="col-sm-8 mt-3">
                                        <h3>{{ product.prdName }}
                                            <i v-if="product.prdIsNew" class="las la-cannabis text-success mx-auto">
                                                new
                                            </i>
                                        </h3>
                                        <div v-if="product.prdProductTypes !== ''">
                                            <span class="font-weight-bold">Type:</span>
                                            <span class="pl-1">{{ product.prdProductTypes }}</span>
                                        </div>
                                        <div v-if="product.prdGenetics">
                                            <span class="font-weight-bold">Genetics:</span>
                                            <span class="pl-1">{{ product.prdGenetics }}</span>
                                        </div>
                                        <div v-if="product.prdTHCPercentage > 0">
                                            <span class="font-weight-bold">THC:</span>
                                            <span class="pl-1">{{ product.prdTHCPercentage }}</span>
                                        </div>
                                        <div v-if="product.prdCBDPercentage > 0">
                                            <span class="font-weight-bold">CBD:</span>
                                            <span class="pl-1">{{ product.prdCBDPercentage }}</span>
                                        </div>
                                        <div class="d-flex">
                                            <template v-if="product.prdPriceByUnit">
                                                <div v-if="product.prdPricePerUnit > 0"
                                                     class="font-weight-bold mt-1 p-1">
                                                    <span class="h5">${{ product.prdPricePerUnit }}</span>
                                                    <br/>
                                                    <span>Price Per Unit</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div v-for="field in priceFields"
                                                     v-if="product[field.fieldName] > 0"
                                                     class="font-weight-bold mt-1 p-1">
                                                    <span class="h5">${{ product[field.fieldName] }}</span>
                                                    <br/>
                                                    <span>{{ field.text }}</span>
                                                </div>
                                            </template>
                                        </div>
                                        <display-review :score="parseInt(product.rvwAverage)"
                                                        :count="product.rvwCount"
                                                        :show-count="true"
                                                        :display-card="true">
                                        </display-review>
                                        <div class="row col-12">
                                            <button class="btn btn-outline-primary col-3 mx-2"
                                                    style="line-height: 15px; border-radius: 40px;">
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td>Products not found, try expanding your search filters</td>
                    </tr>
                </template>
                </tbody>
            </table>

            <div class="list-group mt-3 w-100">
                <pagination :pagination="pagination" @fetch-results="getProducts"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductTab",
    props: {
        business: Object,
        products: Object,
        productFilters: Object,
    },
    data() {
        return {
            filters: {
                page: 1,
                search: "",
                categories: [],
                genetics: [],
            },
            dataProducts: this.products.data,
            pagination: {current: this.products.current_page, last: this.products.last_page},
        }
    },
    computed: {
        priceFields: function () {
            return [
                {fieldName: "prdPriceHalfGram", text: "1/2 Gram"},
                {fieldName: "prdPriceOneGram", text: "1 Gram"},
                {fieldName: "prdPriceTwoGrams", text: "2 Grams"},
                {fieldName: "prdPriceEighthOunce", text: "1/8"},
                {fieldName: "prdPriceQuarterOunce", text: "1/4"},
                {fieldName: "prdPriceHalfOunce", text: "1/2"},
                {fieldName: "prdPriceOneOunce", text: "OZ"},
            ];
        }
    },
    methods: {
        getProducts: function (page) {
            //set page based on the param
            this.filters.page = page;

            //scroll to tab head
            let productTopOffset = this.$refs["productTop"].offsetTop;
            if (window.pageYOffset > productTopOffset)
                window.scrollTo(0, productTopOffset);

            //prepare get request URL & parameters
            let url = "/business/" + this.business.bizBusinessID + "/products";
            let data = {
                page: this.filters.page,
                search: this.filters.search,
                categories: this.filters.categories,
                genetics: this.filters.genetics
            };

            axios.get(url, {params: data}).then(response => {
                // console.log(response);
                this.dataProducts = response.data.data;
                this.pagination.current = response.data.current_page;
                this.pagination.last = response.data.last_page;
            }).catch(error => {
                // console.log(error);
            });
        },
        resetFilters: function () {
            //reset the filter values back to default + re-run the fetch
            this.filters = {
                page: 1,
                search: "",
                categories: [],
                genetics: [],
            };
            this.getProducts();
        },
        getProductURL: function (prdSlug) {
            let url = "/" + this.business.type.plSlug;

            if (![8, 9].includes(this.business.bizBusinessTypeID))
                //when NOT a brand or mail order
                url += "/" + this.business.province.plInitials.toLowerCase() + "/" + this.business.region.plSlug;

            url += "/" + this.business.bizSlug + "/" + prdSlug;

            return url;
        }
    }
}
</script>

<style scoped>
.stick {
    position: sticky;
    top: 0;
}

#applyFilter {
    margin-left: 10px;
    margin-right: 10px;
    line-height: 15px;
    border-radius: 40px;
}
</style>
